import React, { useEffect, useRef } from "react";
import "./landingpage.css";
import BenefitsPage from "./components/BenefitsPage";
import WorkPage from "./components/WorkPage";
import ContactPage from "./components/ContactPage";
import CompanyDetail from "./components/CompanyDetail";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import LandingTableArea from "./components/LandingTableArea";
import TraderFeature from "./components/TraderFeature";

function LandingPage() {
  const homeRef = useRef();
  const featureRef = useRef();
  const benefitRef = useRef();
  const workRef = useRef();
  const contactRef = useRef();
  const isDastop = useMediaQuery({ query: "(max-width: 1600px)" });
  const isLaptop = useMediaQuery({ query: "(max-width: 1500px)" });
  const isSmallLaptop = useMediaQuery({ query: "(max-width: 1200px)" });
  const isTablet = useMediaQuery({ query: "(max-width: 900px)" });
  const isMobile = useMediaQuery({ query: "(max-width: 650px)" });
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({
      duration: 1500, // Duration of the animation in milliseconds
    });
    AOS.refresh();

    document.body.style.overflow = "auto";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  const headerStyle = {
    fontSize: isTablet
      ? "25px"
      : isLaptop
        ? "35px"
        : isDastop
          ? "42px"
          : "50px",
  };

  const scrollToSection = (sectionRef) => {
    const elementPosition = sectionRef.current.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - 140;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  };

  return (
    <div className="header-landing backgroundImage1">
      <div className="page-width" style={{ padding: isTablet && "45px 20px" }}>
        <div
          className="valign-wrapper space-between"
          style={{ marginTop: isMobile && "-25px" }}
        >
          <img
            data-aos="fade-right"
            src="/images/auctionLogo-img.png"
            alt="logo"
            className="auction-landing-img responsive-img"
            style={{ width: isMobile ? "120px" : "" }}
          />
          <button
            data-aos="fade-left"
            className={`valign-wrapper pointer cercle-purple white-text font-16px`}
            style={{
              padding: isMobile ? "5px 15px" : "8px 23px",
              borderRadius: "50px",
              backgroundImage:
                "linear-gradient(to right,rgba(65, 4, 117, 1), rgba(100, 26, 164, 1))",
            }}
            onClick={() => navigate("/login")}
          >
            <span>Login</span>
            <span
              className="material-icons-outlined font-16px "
              style={{ marginLeft: "5px" }}
            >
              arrow_forward
            </span>
          </button>
        </div>
        <LandingTableArea homeRef={homeRef} />
      </div>
      <div className="page-width backgroundImage2">
        <h2
          className="cercle-purple-text font-cercular-bold"
          data-aos="fade-left"
          style={{
            ...headerStyle,
            marginTop: "7%",
          }}
          ref={featureRef}
        >
          Key Features
        </h2>
        <TraderFeature heading={"Key Features"} />

        <div className="full-width benefit" ref={benefitRef}>
          <h1
            data-aos="fade-right"
            className="cercle-purple-text font-cercular-bold"
            style={{
              ...headerStyle,
              marginBottom: isSmallLaptop ? "" : isDastop ? "30px" : "57px",
            }}
          >
            Benefits
          </h1>
          <BenefitsPage />
        </div>
        <div className="full-width benefit" ref={workRef}>
          <h1
            data-aos="fade-right"
            className="cercle-purple-text font-cercular-bold"
            style={{
              ...headerStyle,
            }}
          >
            How It Works
          </h1>
          <WorkPage />
        </div>

        <div className={`full-width mt-3 mb-5`} ref={contactRef}>
          <h1
            data-aos="fade-right"
            className="cercle-purple-text font-cercular-bold"
            style={{
              ...headerStyle,
            }}
          >
            Contact Us
          </h1>
          <ContactPage />
        </div>
        <CompanyDetail
          scrollToSection={scrollToSection}
          homeRef={homeRef}
          featureRef={featureRef}
          benefitRef={benefitRef}
          workRef={workRef}
          contactRef={contactRef}
        />
      </div>
    </div>
  );
}

export default LandingPage;
